import { render, staticRenderFns } from "./calendar-event-all-day-icon.vue?vue&type=template&id=516127d6&scoped=true"
import script from "./calendar-event-all-day-icon.vue?vue&type=script&lang=js"
export * from "./calendar-event-all-day-icon.vue?vue&type=script&lang=js"
import style0 from "./calendar-event-all-day-icon.vue?vue&type=style&index=0&id=516127d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516127d6",
  null
  
)

export default component.exports